import { useGetTradingConfig } from '@ui/services/contract/hooks/TradingConfigFacet/useGetTradingConfig';

export const useGetMaxTakeProfitP = () => {
  const { data: tradingConfig } = useGetTradingConfig();

  return tradingConfig?.maxTakeProfitP;
};
